<template>
    <a-modal :zIndex="10000" v-if="returnVisible" :visible="returnVisible" :footer="null" width="600px" :maskClosable="false" @cancel="closeReturnRateVisible" > 
      <!-- <div style="padding: 20px;"><img src="@images/hd1.jpg" style="width: 100%;"></div> -->
      <div class="dqtitle">各类目退货率一览表</div> 
      <div class="dqtag"> 

        
      <a-table :columns="columns" :rowKey="(record) => record.id"  :data-source="data" :pagination="false" >

      </a-table>


      </div>
    </a-modal>
</template>
  
  <script> 
  const columns = [
    { title: 'ID', dataIndex: 'id', key: 'id',width: 150 },
    {
      title: '类目', 
      dataIndex: 'name',
      key: 'name',
      align:'center',
      scopedSlots: { customRender: 'name' },
    }, 
    {
      title: '退货率', 
      dataIndex: 'rate',
      key: 'rate',
      align:'center',
      scopedSlots: { customRender: 'rate' },
    }, 
  ];
  export default {
    name: 'action',
    props: {
    },
    data() {
        return {  
          columns,
          returnVisible: true,
          data:[
          {id:1,name:'食品',rate:'10%'},
          {id:2,name:'百货',rate:'15%'},
          {id:3,name:'护肤品',rate:'10%'},
          {id:4,name:'小家电',rate:'70%'},
          {id:5,name:'女装',rate:'50%~70%'},
          {id:6,name:'男装',rate:'5%~9%'},
          {id:7,name:'男鞋、女鞋、箱包',rate:'30%~50%'},
          {id:8,name:'珠宝',rate:'90%'},
          {id:9,name:'女包',rate:'30%~40%'},
          ]
        };
    },
  
    components: {
    },
  
    watch: {},
    mounted() { 
      
    },
    methods: {
      closeReturnRateVisible(){
        this.$emit('closeReturnRateVisible')
        return;
      }
    },
  };
  </script>
  
  <style lang="less" scoped> 
.dqtitle{
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  color: #333;
  margin-bottom: 20px
}
.dqtag{
  font-size: 14px;
  color: #333;
  text-align: left; 
}
.dqbtn{
  width: 85%;
  margin: 0 auto;
  margin-top: 20px;
  button{
    margin-bottom: 10px;
    width:100%
  }
}
  </style>
  